export const OptionInformacionData = [
  {
    title: "Mi perfil",
    icon: "MiPerfilIcon",
    link: "/perfil",
    subMenuItems: [],
    key: 13
  },
  {
    title: "Mi grupo familiar",
    icon: "MiGrupoFamiliarIcon",
    link: "/GrupoFamiliar",
    subMenuItems: [],
    key: 14
  },
  {
    title: "Mis médicos",
    icon: "MiMedicoIcon",
    link: "/misMedicos",
    subMenuItems: [],
    key: 15
  },
  {
    title: "Notificaciones",
    icon: "NotificacionIcon",
    link: "/notificaciones",
    subMenuItems: [],
    key: 21
  },
  {
    title: "Beneficios",
    icon: "SugerenciaIcon",
    link: "/beneficiosDim",
    subMenuItems: [],
    key: 16
  },
  {
    title: "Hacer sugerencias",
    icon: "SugerenciaIcon",
    link: "/sugerencia",
    subMenuItems: [],
    key: 17
  },
  {
    title: "Video Tutoriales",
    icon: "VideoTutorial",
    link: "/videoTutoriales",
    subMenuItems: [],
    key: 18
  },
  {
    title: "Ayuda",
    icon: "AyudaIcon",
    link: null,
    subMenuItems: [],
    key: 19
  },

  {
    title: "Salir",
    icon: "SalirIcon",
    link: "/",
    subMenuItems: [],
    key: 20
  },

];
